import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';

const itemStyle = {
  paddingX: 'padding_12',
};

type TProps = {
  sx?: BoxProps['sx'];
  children: ReactNode;
};

const DropdownItem = ({ sx, children }: TProps) => {
  return <Box sx={{ ...itemStyle, ...sx }}>{children}</Box>;
};

export default DropdownItem;
